<script>
  export default {
    props: {
      isLeft: {
        type: Boolean,
        default: false
      },
      dataList: {
        type: Array
      }
    },
    data() {
      return {
        data: [],
        timer: null,
        startIndex: 0,
        addNum: 6
      }
    },
    created() {
      this.getPartData(this.addNum)
    },
    mounted() {
      this.move()
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    methods: {
      getPartData(val) {
        let that = this
        let partData = this.dataList.slice(
          this.startIndex,
          Number(this.startIndex + val)
        )
        partData.forEach(item => {
          that.data.push(item)
        })
        this.startIndex += val
        if (this.startIndex > this.dataList.length) {
          this.startIndex = 0
        }
      },
      move() {
        let that = this
        let marqueeWrap = this.$refs.marqueeWrap
        let scroll = this.$refs.scroll
        let clientdistance = this.isLeft
          ? marqueeWrap.clientWidth
          : marqueeWrap.clientHeight
        let scrolldistance = this.isLeft
          ? marqueeWrap.scrollWidth
          : marqueeWrap.scrollHeight
        let direction = this.isLeft ? 'X' : 'Y'
        if (scrolldistance <= clientdistance) return
        this.getPartData(this.addNum)
        let distance = 0
        this.timer = setInterval(() => {
          let timerInner = setInterval(() => {
            distance -= 1
            scroll.style.transform = `translate${direction}(${(distance * 194) /
              750}vw)`
            if (!(-distance % 26)) {
              clearInterval(timerInner)
            }
          }, 20)
          if (-distance >= scrolldistance) {
            this.getPartData(this.addNum)
            let timePart = setInterval(() => {
              this.data.forEach((item, index) => {
                if (index < this.addNum) {
                  that.data.shift()
                }
                clearInterval(timePart)
              })
            }, 0)
            distance = 0
          }
        }, 2000)
      }
    }
  }
</script>
<template>
  <div class="marquee-wrap" ref="marqueeWrap">
    <div class="scroll" ref="scroll">
      <div class="scroll-left" v-if="isLeft">
        <div v-for="(item, index) in data" :key="index">{{ item }}</div>
      </div>
      <div class="scroll-top" v-else>
        <div v-for="(item, index) in data" :key="index">{{ item }}</div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .marquee-wrap {
    width: 100%;
    height: xvw(50);
    background: rgba(13, 12, 12, 0.4);
    border-radius: xvw(30);
    text-align: center;
    overflow: hidden;
    .scroll {
      word-break: keep-all;
      white-space: nowrap;
      font-size: xvw(28);
      color: #ffffff;
      &-left {
        display: flex;
        div {
          padding: 0 xvw(10);
        }
      }
      &-top {
        div {
          height: xvw(50);
          line-height: xvw(50);
        }
      }
    }
  }
</style>
